import { render, staticRenderFns } from "./BaselineReport_Text.vue?vue&type=template&id=1b4f4620"
import script from "./BaselineReport_Text.vue?vue&type=script&lang=js"
export * from "./BaselineReport_Text.vue?vue&type=script&lang=js"
import style0 from "./BaselineReport_Text.vue?vue&type=style&index=0&id=1b4f4620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports